import React from "react";

const Specification = ({ data }) => {
  return (
    <div className="specifications-list mt-20 ">
      <ul className="border border-gray-300 rounded ">
        {data.specifications?.map((specification) => (
          <li
            key={specification._id}
            className="flex items-center justify-between border-b border-gray-300 py-2"
          >
            <div className="flex-1 px-10 text-xl">
              <strong className="font-bold ">{specification.field}:</strong>{" "}
              {specification.value}
            </div>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default Specification;
